module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_09-236695e9c8d91bda7caef7fb6e49a381.png";